class TextUnderline {
	constructor() {

		const items = document.querySelectorAll(".text-underline");

		items.forEach(elem => {
			gsap.set(elem, {
				backgroundSize: "30% 50%",
			});

			gsap.to(elem, {
				backgroundSize: "100% 50%",
				scrollTrigger: {
					trigger: elem,
					start: 'top 80%',
					end: "+=300",
					scrub: 1,
				}
			});
		});
	}
}
